export const FORMS_LOAD_ERROR = 'Could not load forms.';

export const FORMS_UPDATE_ERROR = 'Could not update form.';

export const FORMS_DUPLICATE_ERROR = 'Could not duplicate form.';

export const FORMS_DUPLICATE_SUCCESS = 'Form duplicated successfully.';

/** Row action labels in the All Forms table. */
export const FORMS_TABLE_ACTION_LABELS = Object.freeze({
  PREVIEW: 'Preview',
  EDIT: 'Edit',
  DISABLE: 'Disable',
  ENABLE: 'Enable',
});

export const FORMS_ROUTE = '/forms';

/** URL hash fragment that opens the Forms tab on its host module (Feeds, Re-Entry Planning). */
export const FORMS_TAB_HASH = 'forms';

export const formEditRoute = (formId) => `${FORMS_ROUTE}/${encodeURIComponent(formId)}`;

export const formSubmissionsRoute = (formId) =>
  `${FORMS_ROUTE}/${encodeURIComponent(formId)}/submissions`;
